import { ActionCreatorWithPayload, createAction} from "@reduxjs/toolkit";
import { AuthToken } from "src/classes/AuthToken";

export namespace QuoterAction {

  export const userLogin: ActionCreatorWithPayload<AuthToken> = createAction<AuthToken>('USER_LOGIN');
}
